<template>
  <div class="container-fluid">
    <div class="row score_page">
      <div class="postgame_modal new_game_not" id="new_game_notification">
        <img :src="getTranslations.project_logo_img" class="logo_img">

        <h1>{{ getTranslations.home_loader_new_game_start}}</h1>
        <h2 v-if="!integrationCheck()">{{ getTranslations.home_loader_win_up }} <span> {{ pointsPerQuestion * numberOfQuestionsPerRound }} {{ getTranslations.home_loader_points }}</span> {{ getTranslations.home_loader_for_the_amazing }}</h2>
        <carousel/>

        <img src="static/images/ball_icon.png" class="unl_games_icon">
        <div class="unl_games_txt">{{ getTranslations.home_loader_unlocked}} {{ userDetails.availableGames }}</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
/* new game notification */
import { mapState, mapGetters, mapMutations } from 'vuex';
import webSocket from '@/common/webSocket';
import { ParseResponseMixin, GameMixin2, GameMixin3 } from '@/common/mixins/game';
import Carousel from '../../../../../ui-src-score/src/components/home/Carousel';

export default {
  name: 'opponent-found',
  components: { Carousel },
  mixins: [ParseResponseMixin, GameMixin2, GameMixin3],
  watch: {
    stompClient: {
      handler() {
        console.log('change to stompclient!');
        // eslint-disable-next-line
        console.log('connected: ' + this.stompClient.connected);
        if (!this.stompClient.connected) this.OnStompClientFailure('lock screen error');
      },
      deep: true,
    },
  },
  data() {
    return {
      stompClient: null,
      subscription: null,
    };
  },
  created() {
    // console.clear();
    this.stompClient = webSocket.getGameStompClient();
    console.log('this.stompClient:', this.stompClient);
    this.getCTAs();
  },
  methods: {
    ...mapMutations('game', [
      'setPlayersCurrentQuestionDTOs',
    ]),
    OnStompClientFailure(error) {
      console.log(error);
      window.location.reload();
    },
    getCTAs() {
      console.log(`Subscribing to channel: /topic/ctasFetched/${this.gameID}`);
      this.subscription = this.stompClient.subscribe(`/topic/ctasFetched/${this.gameID}`, (response) => {
        this.subscription.unsubscribe();
        console.log('[SelectedTheme] Inside ctasFetched response');
        // parse server response and return if any errors occur
        const responseBody = this.parseServerResponse(response.body);
        if (responseBody === null) {
          return;
        }
        const responseData = responseBody.gameDTO;
        console.log('responseData:', responseData);
        if (responseData.gameStateEnum === 'CTA_TO_BE_ANSWERED') {
          this.setPlayersCurrentQuestionDTOs({
            homePlayerQuestionDTO: responseData.homeUserDetails.questionDTO,
          });
          this.normalTransition = true;
          console.log('going to game page');
          this.$router.replace('/game');
        }
      });
    },
    integrationCheck() {
      return this.integrationHeader === this.availableIntegrations.ASIACELL_IRAQ.name;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'pointsPerQuestion',
      'integrationHeader',
      'availableIntegrations',
    ]),
    ...mapState('game', [
      'gameID',
      'numberOfQuestionsPerRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/OpponentFound.vue